/* eslint-disable jsx-a11y/anchor-is-valid */
import {KTCard} from '@/_metronic/helpers/components/KTCard'
import {FC} from 'react'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {DashboardHRManagementOverview} from './DashboardHRManagementOverview'
import {ReportTrendAnalysisListHeader} from './components/filter/ReportTrendAnalysisListHeader'
import {FilterReportTrendAnalysisProvider} from './core/FilterReportTrendAnalysisProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Report',
    path: '',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Sales',
    path: '',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const DashboardHRManagementPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={usersBreadcrumbs}>Dashboard HR Management</PageTitle>
      {/* <KTCard className='py-4 shadow-wit-2'>
        <ReportTrendAnalysisListHeader />
      </KTCard> */}
      <DashboardHRManagementOverview />
    </>
  )
}

const DashboardHRManagementWrapper: FC = () => {
  return (
    <>
      <QueryRequestProvider>
        <FilterReportTrendAnalysisProvider>
          <PageTitle breadcrumbs={[]}>Trend Analysis</PageTitle>
          <DashboardHRManagementPage />
        </FilterReportTrendAnalysisProvider>
      </QueryRequestProvider>
    </>
  )
}

export {DashboardHRManagementWrapper}
